// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5gSnO","right":"styles_right__1jJzk"};